import { useCallback } from 'react'

const useCaptureException = () => {
  const captureException = useCallback(
    (
      e: unknown,
      scopeName = 'default',
      extra: Record<string, unknown> = {}
    ) => {
      console.error('[Exception]', {
        error: e,
        scope: scopeName,
        extra
      })
    },
    []
  )

  return { captureException }
}

export default useCaptureException
